import { registerComponent } from '../registry';
import { COMPONENT_TYPES } from '../../../constants';
import RichEditorComponent from './RichEditor.component';
import RichEditorEditor from './RichEditor.editor';
import RichEditorProperties from './RichEditor.properties';

// 컴포넌트 내보내기
export { default as RichEditorComponent } from './RichEditor.component';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.RICH_EDITOR,
  component: RichEditorComponent,
  editorComponent: RichEditorEditor,
  name: 'RichEditor',
  properties: RichEditorProperties,
  defaultProps: {
    content: '<p>리치 에디터 컴포넌트에 내용을 입력하세요.</p>',
    style: {
      width: '100%',
      minHeight: '200px',
      padding: '20px',
      boxSizing: 'border-box',
      border: '1px solid #eee',
      borderRadius: '4px',
    }
  }
}); 